export default __webpack_public_path__ + "static/media/hi.e5926cb7.svg";